<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <base-card>
          <v-card-title class="d-flex justify-space-between mb-3">
            Students
            <div class="d-flex justify-center align-center">
              <v-text-field
                class="mr-4"
                label="Search"
                append-icon="mdi-magnify"
                v-model="search"
                hide-details
                outlined
                dense
              ></v-text-field>
              <v-btn
                color="primary"
                @click="$router.push({ name: 'create-student' })"
              >
                <v-icon>mdi-plus</v-icon>
                Create New
              </v-btn>
            </div>
          </v-card-title>
          <v-data-table
            item-key="id"
            class="data-table elevation-1"
            :headers="headers"
            :page="getStudentsPage"
            :pageCount="getStudentsPagesNumber"
            :items="getStudents"
            :options.sync="options"
            :server-items-length="getStudentsTotal"
            :loading="getStudentsLoading"
            :items-per-page="25"
            :footer-props="{
              itemsPerPageOptions: [15, 25, -1],
            }"
          >
            <template v-slot:item.actions="{ item }">
              <v-menu
                origin="bottom center"
                :offset-x="true"
                :offset-y="true"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" small v-bind="attrs" v-on="on">
                    Manage
                    <v-icon right class="ml-0">mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list dense class="py-1">
                  <v-list-item
                    @click="
                      $router.push({
                        name: 'edit-student',
                        params: { id: item.id },
                      })
                    "
                  >
                    <v-list-item-icon class="mr-1">
                      <v-icon dense>mdi-pencil</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="showRemoveDialog(item)">
                    <v-list-item-icon class="mr-1">
                      <v-icon dense>mdi-trash-can</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    v-if="item.customer_id"
                    @click="
                      $router.push({
                        name: 'edit-student-course',
                        params: { id: item.id },
                      })
                    "
                  >
                    <v-list-item-icon class="mr-1">
                      <v-icon dense>mdi-book-multiple</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Courses</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item @click="showResendDialog(item)">
                    <v-list-item-icon class="mr-1">
                      <v-icon dense>mdi-account-reactivate</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        >Resend Signup Details</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    @click="
                      $router.push({
                        path: `/app/progress-report/${item.id}`,
                      })
                    "
                  >
                    <v-list-item-icon class="mr-1">
                      <v-icon dense>mdi-account-clock</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Progress Report</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </base-card>
        <template v-if="selected">
          <v-row justify="center">
            <v-dialog max-width="400" v-model="dialog">
              <v-card>
                <v-card-title>Resend Signup Details</v-card-title>
                <v-card-text>
                  Are you sure you want to create a new password and send this
                  to <strong>{{ selected.email }}</strong>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialog = false"> Cancel </v-btn>
                  <v-btn color="primary" text @click="resendSignupDetails">
                    Ok
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
        <template v-if="selected">
          <v-row justify="center">
            <v-dialog max-width="350" v-model="removeDialog">
              <v-card>
                <v-card-title>Delete Student</v-card-title>
                <v-card-text>
                  Are you sure you want to delete this student? This action
                  cannot be undone.
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="removeDialog = false"> Cancel </v-btn>
                  <v-btn color="danger" text @click="remove"> Delete </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { assign, first, get } from "lodash";
import { mapActions, mapGetters } from "vuex";

export default {
  metaInfo: {
    title: "Students",
  },
  data() {
    return {
      selected: null,
      dialog: false,
      removeDialog: false,
      search: null,
      options: {},
      headers: [
        { text: "Name", value: "name" },
        { text: "Username", value: "username" },
        { text: "Email", value: "email" },
        { text: "Customer", value: "customer.description", sortable: false },
        { text: "Actions", value: "actions", align: "center", sortable: false },
      ],
    };
  },
  methods: {
    ...mapActions([
      "setStudents",
      "deleteStudent",
      "sendStudentLoginDetails",
      "toggleDisabledStatus",
    ]),

    paginate() {
      console.log("🚀 ~ student ~ options.this.options:", this.options);
      const options = {
        page: this.options.page,
        perPage: this.options.itemsPerPage,
        sortBy: first(this.options.sortBy),
        sortDesc: first(this.options.sortDesc),
      };

      if (this.search) {
        assign(options, { search: this.search });
      }

      this.setStudents(options);
    },

    showRemoveDialog(student) {
      this.selected = student;
      this.removeDialog = true;
    },

    async remove() {
      if (this.selected) {
        const payload = {
          disabled: get(this.selected, "disabled"),
        };

        await this.toggleDisabledStatus({
          id: get(this.selected, "id"),
          payload,
        });
      }

      this.selected = null;
      this.removeDialog = false;
    },

    showResendDialog(student) {
      this.selected = student;
      this.dialog = true;
    },

    async resendSignupDetails() {
      if (this.selected) {
        await this.sendStudentLoginDetails({ id: get(this.selected, "id") });
      }

      this.selected = null;
      this.dialog = false;
    },
  },
  computed: {
    ...mapGetters([
      "getStudents",
      "getStudentsPage",
      "getStudentsTotal",
      "getStudentsPagesNumber",
      "getStudentsLoading",
    ]),

    paginationOptions() {
      return this.options && this.search;
    },
  },
  watch: {
    paginationOptions: {
      handler() {
        this.paginate();
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped></style>
